module.exports = __webpack_public_path__ + "img/rebuild_huang_mob4.05c456d3.jpg";